module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pn-ab7259a94ec182c05827fd8bd1a3e445.svg";